document.addEventListener('turbolinks:load', function() {
    const lmsHeader = document.querySelector(".lms-header__bar");
    const bannerContainer = document.querySelector(".la-banner-container");
    const advantageHeader = document.querySelector("#advantage-header");

    if (window.location !== window.parent.location) {
        // in iframe
        if (lmsHeader) lmsHeader.style.display = "none";
        if (bannerContainer) bannerContainer.style.display = "flex";
    } else {
        // not in iframe
        if (lmsHeader) lmsHeader.style.display = "flex";
        if (bannerContainer) bannerContainer.style.display = "none";
    }

    if (advantageHeader) advantageHeader.style.display = "grid";
});